import React, { useState, useEffect } from 'react';
import './Shop.css';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export function Shop() {
  const navigate = useNavigate();
  const [outdoorProducts, setOutdoorProducts] = useState([]);
  const [indoorProducts, setIndoorProducts] = useState([]);
  const [sortingSeed] = useState(Math.floor(Math.random() * 1000) + 1);

  useEffect(() => {
    const params = new URLSearchParams({ PageNumber: 1, PageSize: 100, SortingIndex: sortingSeed });

    fetch(`api/Shop/GetProducts?${params}&ForOutdoor=true`)
      .then(r => r.json())
      .then(data => setOutdoorProducts(data.products));

    fetch(`api/Shop/GetProducts?${params}&ForOutdoor=false`)
      .then(r => r.json())
      .then(data => setIndoorProducts(data.products));
  }, []);

  const handleProductSelect = (technicalName) => {
    navigate(`/product/${technicalName}`);
  };

  const renderProductGrid = (products) => (
    <div className="product-grid">
      {products.map((product) => (
        <div onClick={() => handleProductSelect(product.technicalName)} key={product.technicalName} className="product-card">
          <div className="product-card-image-wrap">
            <img src={product.image} alt={product.name} />
          </div>
          <div className="product-card-name">{product.name}</div>
          {product.availability &&
            <div className="product-card-meta">
              <span className="product-availability-dot" style={{ backgroundColor: product.availability }}></span>
              <p className="product-card-price">{product.price}</p>
            </div>
          }
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <Helmet>
        <title>Pouf Shop – Bouclé, Leinen & Outdoor-Poufs kaufen | ho.li design</title>
        <meta name="description" content="Entdecke unseren Pouf-Shop: handgefertigte Sitzsäcke aus Bouclé, Leinen & Outdoor-Stoff, in verschiedenen Farben & Größen. Jetzt online bestellen." />
        <meta name="keywords" content="Pouf Shop, Sitzsack online kaufen, Bouclé Pouf, Leinen Sitzsack, Outdoor Pouf, ho.li design Shop" />
        <meta name="language" content="de" />
        <link rel="canonical" href="https://holidesign.de/shop" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Pouf Shop – Bouclé, Leinen & Outdoor-Poufs kaufen | ho.li design" />
        <meta property="og:description" content="Entdecke unseren Pouf-Shop: handgefertigte Sitzsäcke aus Bouclé, Leinen & Outdoor-Stoff, in verschiedenen Farben & Größen. Jetzt online bestellen." />
        <meta property="og:url" content="https://holidesign.de/shop" />
        <meta property="og:image" content="https://saholiprod2.blob.core.windows.net/sc-holi-prod2/inscene.jpeg" />
        <meta property="og:site_name" content="ho.li design" />
        <meta property="og:locale" content="de_DE" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <h1 style={{ marginBottom: '40px' }}>Shop</h1>

      {indoorProducts.length > 0 && (
        <section style={{ marginBottom: '56px' }}>
          <h2 style={{ marginBottom: '32px' }}>Indoor Poufs</h2>
          {renderProductGrid(indoorProducts)}
        </section>
      )}

      {outdoorProducts.length > 0 && (
        <section style={{ marginBottom: '56px' }}>
          <h2 style={{ marginBottom: '32px' }}>Outdoor Poufs</h2>
          {renderProductGrid(outdoorProducts)}
        </section>
      )}
    </div>
  );
}
